export default "__VITE_ASSET__DJX3aiUi__"